<script>
exports.UserStatsService = (api, handleError) => {
  const basePath = '/stats'
  const adminPath = `/admin${basePath}`

  const getList = async ({ owner = null, role, activeUsers, page, sort }) => {
    try {
      if (owner) {
        return await api.get(`${adminPath}/user/${owner}`)
      }
      const qs = new URLSearchParams()
      qs.append('role', role || 'all')
      qs.append('users', activeUsers ? 'active' : 'all')
      qs.append('page', Number(page) || 1)
      qs.append('sort', sort)
      return await api.get(`${adminPath}/list?${qs.toString()}`)
    } catch (error) {
      return handleError(error)
    }
  }

  const refreshData = async () => {
    try {
      return await api.post(`${adminPath}/import`)
    } catch (error) {
      return handleError(error)
    }
  }

  return {
    Admin: {
      getList,
      refreshData
    }
  }
}
</script>
